import React, { useEffect, useState } from "react";
import { logo } from "../../assets/index";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const Links = [
    { name: "Home", link: "/" },
    { name: "Services", link: "/" },
    { name: "About", link: "/" },
    { name: "Contact", link: "/" },
  ];

  const transitionNavbar = () => {
    if (window.scrollY > 50) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavbar);
    return () => window.removeEventListener("scroll", transitionNavbar);
  }, []);

  return (
    <div
      className={`flex items-center justify-between flex-wrap top-0 sticky w-full z-50 p-3 transition ease-in ${
        show && "bg-[#fff]"
      }`}
    >
      <div className="flex items-center justify-between text-gray-800 w-full">
        <div className="flex items-center">
          <img
            src={logo}
            className="w-50 h-20 mr-1 text-[rgb(82, 82, 96)]"
            alt="logo"
          />
          <span className="text-xl text-black mr-1 pt-2">Chabbikar</span>
        </div>
        <div onClick={() => setOpen(!open)}>
          {open ? (
            <AiOutlineClose className="h-7 w-7 cursor-pointer" />
          ) : (
            <GiHamburgerMenu className="h-7 w-7 cursor-pointer" />
          )}
        </div>

        <ul
          className={`md:flex md:items-center md:pb-0 pt-20 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${
            open ? "top-0" : "top-[-490px]"
          }`}
        >
          {Links.map((link) => (
            <li key={link.name} className="md:ml-8 text-xl md:my-0 my-7">
              <a
                href={link.link}
                className="text-gray-800 hover:text-[#5956e9] duration-200"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
